module.exports = __webpack_public_path__ + "media/stylesheets/images/Keiki Yokokawa-9054c070449a8d18bbfe7aa88b51c8fe.jpg";